import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrdersCsv } from '../../store/actions/history';
import _ from "lodash";
import PropTypes from 'prop-types';

const ExportOrderCsv = (props) => {
    const { gridData, csvData, idList } = props;
    const [btnClicked, setBtnClicked] = useState(false);

    const { csvUrl } = useSelector((state) => state.HistoryReducer);
    const dispatch = useDispatch();

    useEffect(() => {
        csvUrl && btnClicked && window.open(csvUrl);
    }, [csvUrl, btnClicked]);

    const handleOpenCsv = async () => {
        setBtnClicked(true);
        let dataServiceIdList = _.map(csvData.serviceIdList, "id");
        let dataCarrierIdList = _.map(csvData.carrierIdList, "id");
        let data = { ...csvData, shipmentIdList: idList, serviceIdList: dataServiceIdList, carrierIdList: dataCarrierIdList };
        dispatch(getOrdersCsv(data));
    }

    return (
        <button
            className="cus-seconday-bg-btn noBtn"
            disabled={!gridData.length}
            onClick={handleOpenCsv}
        >
            Export CSV
        </button>
    );
}

ExportOrderCsv.propTypes = {
    gridData: PropTypes.array,
    csvData: PropTypes.object,
    idList: PropTypes.array,
};

export default ExportOrderCsv;